$(document).ready(function(){
    
	(function ($) {
  		var imageW = 500;
        var imageH = 500;
        var fitImagestoContainers = true;
        var descriptionOnRollover = false;
        var firstLoad = true;
    
    
//        var containerClass;
        var imageContainerWidth;
        var imageContainerHeight;
		
        adjustContainers();

        $(window).resize(function () {
         adjustContainers();
         $('.image_container_large .product_img').removeAttr('style');
         $('.image_container_large .product_img').css('visibility', 'visible');
         $('.image_container_large .product_img').each(function(){
           	adjustImageSize($(this), imageContainerHeight);
         });
       });    
       

       function adjustContainers() {    
         
         imageContainerWidth = $('.image_container_large').width();
         imageContainerHeight = ( imageH / imageW) * imageContainerWidth;
         
         var productInfoContainerH = $('.product_info').height();
         
         $('.image_container_large').css('height', imageContainerHeight + 'px');
         $('.product_container').css('min-height', imageContainerHeight + productInfoContainerH + 'px');

         $('.image_container_large img').removeAttr('style');  

          if(firstLoad) {
              loadImages();
              firstLoad = false;   
           } else {
             adjustImageSize($(this), imageContainerHeight);
           }
         
       };
       
       function loadImages(){
            $('.image_container_large').each(function(){
              var image_container = $(this);
              if(image_container.hasClass('loading')) {  
                
                
                var main_image = image_container.children('.product_img');
//                 main_image.attr('src', main_image.attr('id'));
                $(main_image).each(function(){

                    $(this).attr('src', $(this).attr('id'));
                });
                main_image.load(function(){

                  adjustImageSize($(this), imageContainerHeight); 

//                   if (descriptionOnRollover)
                    image_container.hover(showProductDetails, hideProductDetails);
                 

                  image_container.removeClass('loading');
                  
                  if($(this).hasClass('one_of_two')){                  
                    var duration = Math.floor(Math.random()*1000);
                    main_image.css('visibility','visible').hide().fadeIn(duration);
                    image_container.siblings('.product_info').css('visibility','visible').hide().fadeIn(duration);
                    image_container.parent().css('visibility','visible').hide().fadeIn(duration);
                  }else {
                    console.log("setting 0");
                     $(this).css('opacity', '0');
                  }                  
                  
                });
              }
            });           
       }

       function adjustImageSize(image, containerHeight) {
           var imageHeight = $(image).height();
           var imageWidth = $(image).width();
           if(fitImagestoContainers) {
             if(imageHeight > containerHeight) {
               var newW = (imageWidth / imageHeight) * containerHeight;
               $(image).css('width', newW + 'px');
             } 
           } else {
             if(imageHeight < containerHeight) {
                $(image).css('height', containerHeight + 'px');
                $(image).css('width', 'auto');
                var newW = $(image).width();
                $(image).css('left', ((newW - imageContainerWidth) / 2) * -1 + 'px');

              } else {
                $(image).addClass('height_greater');
                $(image).css('top', ((imageHeight - containerHeight) / 2) * -1 + 'px');
              }             
             
             
           }
           if($(image).hasClass('two_of_two'))
             $(image).css('opacity', '0');

       }
     
    
        function showProductDetails(){
          $(this).children(".product_popup_info").css('display', 'inline-block');
//           $(this).addClass('imageFade');
        }

        function hideProductDetails(){
          $(this).children(".product_popup_info").css('display', 'none');
//           $(this).removeClass('imageFade');
        }       

})(jQuery);
  
});

